import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

const STORAGE_KEY_TOKEN = 'ft_token';
const STORAGE_KEY_USER  = 'ft_user';
const SESSION_KEY_TOKEN = 'ft_session_token';
const SESSION_KEY_USER  = 'ft_session_user';

// Helper: ambil token dari localStorage ATAU sessionStorage
function getStoredToken() {
  return localStorage.getItem(STORAGE_KEY_TOKEN) || sessionStorage.getItem(SESSION_KEY_TOKEN);
}
function getStoredUser() {
  try {
    const ls = localStorage.getItem(STORAGE_KEY_USER);
    if (ls) return JSON.parse(ls);
    const ss = sessionStorage.getItem(SESSION_KEY_USER);
    if (ss) return JSON.parse(ss);
  } catch {}
  return null;
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredUser());
  const [loading, setLoading] = useState(false);

  const login = async (email, password, rememberMe = false) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      if (data.success) {
        if (rememberMe) {
          // Remember Me: simpan di localStorage (bertahan setelah browser tutup)
          localStorage.setItem(STORAGE_KEY_TOKEN, data.token);
          localStorage.setItem(STORAGE_KEY_USER, JSON.stringify(data.user));
          sessionStorage.removeItem(SESSION_KEY_TOKEN);
          sessionStorage.removeItem(SESSION_KEY_USER);
        } else {
          // Tidak remember: simpan di sessionStorage (hilang saat browser ditutup)
          sessionStorage.setItem(SESSION_KEY_TOKEN, data.token);
          sessionStorage.setItem(SESSION_KEY_USER, JSON.stringify(data.user));
          localStorage.removeItem(STORAGE_KEY_TOKEN);
          localStorage.removeItem(STORAGE_KEY_USER);
        }
        setUser(data.user);
        return { success: true, user: data.user };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || 'Login gagal' };
    } finally {
      setLoading(false);
    }
  };

  // Ganti Shift POS: pakai sesi kasir penerima di penyimpanan yang sama dengan
  // sesi sekarang (remember me tetap ikut), tanpa lewat halaman login.
  const gantiSesi = (token, nextUser) => {
    const pakaiLocal = !!localStorage.getItem(STORAGE_KEY_TOKEN);
    const simpan = pakaiLocal ? localStorage : sessionStorage;
    const buang = pakaiLocal ? sessionStorage : localStorage;
    simpan.setItem(pakaiLocal ? STORAGE_KEY_TOKEN : SESSION_KEY_TOKEN, token);
    simpan.setItem(pakaiLocal ? STORAGE_KEY_USER : SESSION_KEY_USER, JSON.stringify(nextUser));
    buang.removeItem(pakaiLocal ? SESSION_KEY_TOKEN : STORAGE_KEY_TOKEN);
    buang.removeItem(pakaiLocal ? SESSION_KEY_USER : STORAGE_KEY_USER);
    setUser(nextUser);
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY_TOKEN);
    localStorage.removeItem(STORAGE_KEY_USER);
    sessionStorage.removeItem(SESSION_KEY_TOKEN);
    sessionStorage.removeItem(SESSION_KEY_USER);
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get('/auth/me');
      if (data.success) {
        // Update di storage yang aktif
        if (localStorage.getItem(STORAGE_KEY_TOKEN)) {
          localStorage.setItem(STORAGE_KEY_USER, JSON.stringify(data.user));
        } else {
          sessionStorage.setItem(SESSION_KEY_USER, JSON.stringify(data.user));
        }
        setUser(data.user);
      }
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, gantiSesi }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
